import { ENVIRONMENT } from '@evc/platform';
import { baseEnvironment } from './environment.base';
import { AppEnv } from './environment.base';

export const environment: AppEnv = {
  ...baseEnvironment,
  ENV: ENVIRONMENT.development,
  AUTH_CLIENT_ID: '4f0f2181-14b5-4822-b7b2-3fe2b45b284a',
  PROTECTED_URIS: {
    DEMOAPP: "https://demoapp.api.ca.connect.dev-evcnt.com",
  },
  DEBUG_AUTH_FLOW: true,
};
